// src/components/auth/ForgotPassword.jsx
import React, { useState } from 'react';
import AuthForm from './AuthForm';
import { useNavigate } from 'react-router-dom'; // ✅ for navigation
import AuthManager from '../../../services/dashboard/AuthManager';
import toast from 'react-hot-toast';

export default function ForgotPassword() {
  const [identifier, setIdentifier] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await AuthManager.requestPasswordResetOtp(identifier); // ✅ call backend API
  
      if (res.errorCode) {
        // ✅ Backend says it's an error
        toast.error(res.responseMessage || 'Something went wrong');
      } else {
        toast.success(res.responseMessage || 'OTP sent to your email');
  
        // ✅ Navigate to OTP Verification page and pass email
        navigate('/verification', { state: { identifier } });
      }
  
    } catch (err) {
      // This block only catches network errors (e.g., no internet)
      toast.error('Network error, please try again');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthForm
      title="Forgot Password?"
      imageSrc="/images/forgot password img.svg"
      footer={null}
    >
      <form className="space-y-4 max-w-md mx-auto" onSubmit={handleSubmit}>

        <input
          type="text"
          name="identifier"
          placeholder="Email or mobile number"
          value={identifier}
          onChange={e => setIdentifier(e.target.value)}
          required
          className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-[#FF7236]"
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-[#FF7236] hover:bg-[#EB5E22] text-white py-2 rounded disabled:opacity-50"
        >
          {loading ? 'Continuing...' : 'Continue'}
        </button>
      </form>
    </AuthForm>
  );
}
